import { APP_TYPES } from "constants/AppTypes";

// Returns the SessionType string expected by the backend enum:
//   "Web"    = Controller (phone/mobile)
//   "Device" = Host       (desktop browser, TV)
// The server applies the same UA fallback if this field is absent, so this stays
// an override — not a requirement — during client rollout.
export const resolveSessionCategory = (appType) => {
    switch (appType) {
        case APP_TYPES.FIRE_TV:
        case APP_TYPES.SAMSUNG:
        case APP_TYPES.ROKU:
        case APP_TYPES.SKY:
            return "Device";
        case APP_TYPES.MOBILE_APP:
            return "Web";
        case APP_TYPES.WEB:
        default:
            return isMobileBrowser() ? "Web" : "Device";
    }
};

const isMobileBrowser = () => {
    if (typeof navigator === "undefined") return false;
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent || "");
};
